import SMSDetailsView from '../Views/App-Views/SMS/SMSDetailsView';
import FAQAppComponent from '../Views/App-Views/FAQ/FAQAppComponent';
import RicAppComponent from '../Views/App-Views/RIC/RicAppComponent';
import BLUAppComponent from '../Views/App-Views/BLU/BLUAppComponent';
import MATAppComponent from '../Views/App-Views/MAT/MATAppComponent';
import CAMAppComponent from '../Views/App-Views/CAM/CAMAppComponent';
import AamUserManagementTool from '../Views/App-Views/ALL-AAT/webparts/AamUserManagementAppComponent';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Login from 'Views/Auth-Views/Login';
import PrivateRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import { UtilsComponent } from 'Components';
import UnAuthorized from '../Views/App-Views/CommonPages/UnAuthorize';
import { Users, CreateUser, ViewUsers, CommunityPermission, SMS, CreateSMS, MaintenanceSetup } from 'Views/App-Views';
import { InvoiceUploadWizard, BatchList, BatchDetail } from '../Views/App-Views/VMSInvoice';
import PrefixPath from 'config/AppConfig';
import AccountInfo from '../Views/App-Views/RIC/webparts/ric/components/RIC/Accounts/AccountInfo';
import Submissions from '../Views/App-Views/TenantSubmissions/Submissions';
import SubmissionDetails from '../Views/App-Views/TenantSubmissions/SubmissionDetails';
import Disclaimer from '../Views/App-Views/Disclaimers/Disclaimers';
import RegistrationFee from '../Views/App-Views/RegistrationFees/RegistrationFees';
import { CommonText } from '../Constant/CommonText';
import { PAGE_CODES } from '../Constant/Roles';
import CatAppComponent from 'Views/App-Views/CAT/CATAppComponent';
import navigationConfig from 'config/NavigationConfig';
import UserData from '../utils/UserData';

const { MainLayout } = UtilsComponent;

const filterNavByAccess = (routes, accessPages) => {
  if (!accessPages || !Array.isArray(accessPages)) return routes;

  return routes
    .map(route => {
      const hasDirectAccess = accessPages.includes(route?.key);

      let children = [];
      if (route.children) {
        children = filterNavByAccess(route.children, accessPages);
      }

      if (hasDirectAccess || children.length > 0) {
        return {
          ...route,
          children,
        };
      }

      return null;
    })
    .filter(Boolean);
};

const getFirstAccessibleRoute = (routes) => {
  for (const route of routes) {
    if (route.children && route.children.length > 0) {
      const child = getFirstAccessibleRoute(route.children);
      if (child) return child;
    }

    if (route.path) {
      return route.path;
    }
  }

  return null;
};

const DefaultRedirect = () => {
  const accessPages = UserData()?.getAccessPages?.() || [];
  const userRoutes = navigationConfig?.userRoles["admin"] || [];

  const filteredRoutes = filterNavByAccess(userRoutes, accessPages);
  const firstRoute = getFirstAccessibleRoute(filteredRoutes);

  const fallback = `${PrefixPath.APP_PREFIX_PATH}/home`;

  return <Navigate to={firstRoute || fallback} replace />;
};

const HomeElement = () => (
  <div className="text-center">
    {CommonText.WELCOME} <strong>{CommonText.APP_NAME_TEXT}!</strong>
    <p><i>{CommonText.HOME_TEXT}</i></p>
  </div>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute element={<DefaultRedirect />} />,
  },
  {
    path: "/AAM/",
    element: <PrivateRoute element={<DefaultRedirect />} />,
  },
  {
    path: `${PrefixPath.APP_PREFIX_PATH}/`,
    element: <MainLayout/>,
    children: [
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/user`,
        element: <PrivateRoute element={<Users/>} requiredPageCode={PAGE_CODES.ALL_ACCESS_USERS} />,
        handle: { title: "All Access" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/user/userDetails/:id`,
        element: <PrivateRoute element={<ViewUsers/>} requiredPageCode={PAGE_CODES.USER_DETAILS} />,
        handle: { title: "All Access" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/user/CreateUser`,
        element: <PrivateRoute element={<CreateUser/>} requiredPageCode={PAGE_CODES.CREATE_USER} />,
        handle: { title: "All Access" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/admin-tool`,
        element: <PrivateRoute element={<AamUserManagementTool/>} requiredPageCode={PAGE_CODES.ALL_AAT} />,
        handle: { title: "All Access" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/community/permissions`,
        element: <PrivateRoute element={<CommunityPermission/>} requiredPageCode={PAGE_CODES.COMMUNITY_PERMISSIONS} />,
        handle: { title: "All Access" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/blu`,
        element: <PrivateRoute element={<BLUAppComponent/>} requiredPageCode={PAGE_CODES.BLU} />,
        handle: { title: "BLU" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/maintenance-setup`,
        element: <PrivateRoute element={<MaintenanceSetup/>} requiredPageCode={PAGE_CODES.SCHEDULE_MAINTENANCE} />,
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/cam`,
        element: <PrivateRoute element={<CAMAppComponent/>} requiredPageCode={PAGE_CODES.CAM} />,
        handle: { title: "CAM" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/cat`,
        element: <PrivateRoute element={<CatAppComponent/>} requiredPageCode={PAGE_CODES.CAT} />,
        handle: { title: "CAT" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/faq`,
        element: <PrivateRoute element={<FAQAppComponent />} requiredPageCode={PAGE_CODES.FAQ} />,
        handle: { title: "FAQ" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/mat`,
        element: <PrivateRoute element={<MATAppComponent/>} requiredPageCode={PAGE_CODES.MAT} />,
        handle: { title: "MAT" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/ric`,
        element: <PrivateRoute element={<RicAppComponent/>} requiredPageCode={PAGE_CODES.RIC} />,
        handle: { title: "RIC" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/Ric/Account/:id`,
        element: <PrivateRoute element={<AccountInfo/>} requiredPageCode={PAGE_CODES.ACCOUNT_INFO} />,
        handle: { title: "RIC" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/sms`,
        element: <PrivateRoute element={<SMS/>} requiredPageCode={PAGE_CODES.SMS} />,
        handle: { title: "SMS" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/sms/create`,
        element: <PrivateRoute element={<CreateSMS/>} requiredPageCode={PAGE_CODES.SMS} />,
        handle: { title: "SMS" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/sms/:id`,
        element: <PrivateRoute element={<SMSDetailsView/>} requiredPageCode={PAGE_CODES.SMS} />,
        handle: { title: "SMS" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/TenantRegistrations`,
        element: <PrivateRoute element={<Submissions/>} requiredPageCode={PAGE_CODES.TENANT_REGISTRATIONS} />,
        handle: { title: "Tenant Registration" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/TenantRegistrations/View/`,
        element: <PrivateRoute element={<SubmissionDetails/>} requiredPageCode={PAGE_CODES.TENANT_REGISTRATIONS_SUBMISSIONS} />,
        handle: { title: "Tenant Registration" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/Disclaimers`,
        element: <PrivateRoute element={<Disclaimer/>} requiredPageCode={PAGE_CODES.TENANT_REGISTRATIONS_DISCLAIMERS} />,
        handle: { title: "Tenant Registration" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/RegistrationFees`,
        element: <PrivateRoute element={<RegistrationFee/>} requiredPageCode={PAGE_CODES.TENANT_REGISTRATIONS_FEES} />,
        handle: { title: "Tenant Registration" }
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/vms-invoice/upload`,
        element: <PrivateRoute element={<InvoiceUploadWizard/>} requiredPageCode={PAGE_CODES.VMS_INVOICE_UPLOAD} />,
        handle: { title: "VMS Invoices" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/vms-invoice/batches`,
        element: <PrivateRoute element={<BatchList/>} requiredPageCode={PAGE_CODES.VMS_INVOICE_BATCHES} />,
        handle: { title: "VMS Invoices" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/vms-invoice/batches/:batchId`,
        element: <PrivateRoute element={<BatchDetail/>} requiredPageCode={PAGE_CODES.VMS_INVOICE_BATCHES} />,
        handle: { title: "VMS Invoices" },
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/community/permissions/:id`,
        element: <PrivateRoute element={<CommunityPermission/>} requiredPageCode={PAGE_CODES.COMMUNITY_PERMISSIONS} />,
      },
      {
        path: `${PrefixPath.APP_PREFIX_PATH}/unauthorized`,
        element: <PrivateRoute element={<UnAuthorized/>} />,
      },
    ],
  },
  {
    path: `/login`,
    element: '',
    children: [
      {
        path: `/login`,
        element: <PublicRoute element={<Login />} />,
      },
    ],
  },
]);

export default router;
